import PropTypes from 'prop-types';
import React from 'react';
import Panel from './Panel'
import MaterialDetail from './MaterialDetail';
import MaterialSummary from './MaterialSummary';
import { Prepreg } from '../../../models';

export const PrepregPanel = ({
  expanded,
  onToggle,
  material,
  lengthUnit
}) => (
  <Panel
    expanded={expanded}
    onToggle={onToggle}
    summary={<MaterialSummary material={material} lengthUnit={lengthUnit} />}
    detail={<MaterialDetail material={material} />}
  />
);

PrepregPanel.propTypes = {
  material:   PropTypes.instanceOf(Prepreg).isRequired,
  expanded:   PropTypes.bool.isRequired,
  onToggle:   PropTypes.func.isRequired,
  lengthUnit: PropTypes.string.isRequired,
}

export default PrepregPanel;



// WEBPACK FOOTER //
// ./src/components/common/MaterialPanel/Prepreg.js